import React from 'react';
import { Box, Image } from '@chakra-ui/react';
import Heading from '#coreComponents/Heading';

import customersAroundTheWorldImage from '../images/world_data_customers_v2_0.png';

const HomeWorld = () => (
  <Box>
    <Heading as="h1" mb={6} textAlign="center">
      Trusted by universities around the world
    </Heading>
    <Image
      alt="Datapoints customers around the world"
      src={customersAroundTheWorldImage}
    />
  </Box>
);

export default HomeWorld;
